export const categoryDropdown = () => [
  { id: 'A', description: 'Support' },
  { id: 'B', description: 'Customer Service' },
  { id: 'C', description: 'Servicing' },
  { id: 'D', description: 'New Sale' },
  { id: 'E', description: 'Complaint' },
];
